import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LucideAngularModule, AlertCircle } from 'lucide-angular';

@Component({
  selector: 'app-chat-error',
  standalone: true,
  imports: [CommonModule, LucideAngularModule],
  templateUrl: './chat-error.component.html',
  styleUrl: './chat-error.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatErrorComponent {
  readonly error = input.required<string>();

  readonly retryClicked = output<void>();

  protected readonly icons = {
    AlertCircle,
  };

  protected onRetryClick(): void {
    this.retryClicked.emit();
  }
}
